// timesheetConstants.js

export const TIMESHEET_CREATE_REQUEST = 'TIMESHEET_CREATE_REQUEST';
export const TIMESHEET_CREATE_SUCCESS = 'TIMESHEET_CREATE_SUCCESS';
export const TIMESHEET_CREATE_FAIL = 'TIMESHEET_CREATE_FAIL';
export const TIMESHEET_CREATE_RESET = 'TIMESHEET_CREATE_RESET';

export const TIMESHEET_LIST_REQUEST = 'TIMESHEET_LIST_REQUEST';
export const TIMESHEET_LIST_SUCCESS = 'TIMESHEET_LIST_SUCCESS';
export const TIMESHEET_LIST_FAIL = 'TIMESHEET_LIST_FAIL';

export const TIMESHEET_DETAILS_REQUEST = 'TIMESHEET_DETAILS_REQUEST';
export const TIMESHEET_DETAILS_SUCCESS = 'TIMESHEET_DETAILS_SUCCESS';
export const TIMESHEET_DETAILS_FAIL = 'TIMESHEET_DETAILS_FAIL';

export const TIMESHEET_UPDATE_REQUEST = 'TIMESHEET_UPDATE_REQUEST';
export const TIMESHEET_UPDATE_SUCCESS = 'TIMESHEET_UPDATE_SUCCESS';
export const TIMESHEET_UPDATE_FAIL = 'TIMESHEET_UPDATE_FAIL';

export const TIMESHEET_DELETE_REQUEST = 'TIMESHEET_DELETE_REQUEST';
export const TIMESHEET_DELETE_SUCCESS = 'TIMESHEET_DELETE_SUCCESS';
export const TIMESHEET_DELETE_FAIL = 'TIMESHEET_DELETE_FAIL';
export const TIMESHEET_DELETE_RESET = 'TIMESHEET_DELETE_RESET';